import i from "./useMakeApostleTicket.js";
import * as o from "ramda";
const u = () => {
  const {
    makeApostleTicket: a
  } = i();
  return {
    makeApostleMintConfig: (c) => o.pathOr([], ["frontendConfig", "mint_config", "apostle"], c).map((e) => ({
      season: e.season,
      seasonMintType: e.season_mint_type,
      forgePricesByStage: e.forge_price ? e.forge_price.map((r) => r.map((t) => ({
        currencyCode: t.currency_code,
        value: t.value,
        name: t.name
      }))) : void 0,
      tickets: e.ticket_id.map(a),
      maxReserve: e.reserved_slot_max_count,
      mintCooldown: e.reserve_slot_update_time_limit_in_day,
      maxTicketSelect: e.ticketing_mint_max_count,
      beginTime: e.begin_time,
      endTime: e.end_time,
      maxClassLimit: e.max_class_limit,
      prices: e.price_list ? e.price_list.map((r) => ({
        currencyCode: r.currency_code,
        price: r.price
      })) : void 0,
      reforgePriceGroup: e.reforge_price_default_group || "",
      reforgePriceConfigs: (e.reforge_price || []).map((r) => ({
        priceGroups: r.price.map((t) => ({
          priceGroup: t.group,
          prices: t.currencies.map((s) => ({
            code: s.currency_code,
            value: s.value
          }))
        })),
        reforgeCount: r.reforge_count
      })),
      apostleSealedDays: e.reserve_slot_update_time_limit_in_day
    }))
  };
};
export {
  u as default
};
//# sourceMappingURL=useMakeApostleMintConfig.js.map
